import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription, take } from 'rxjs';
import { IRemarkSavedOnProccess, PnrInfo } from 'src/app/core/models/itinerary.model';
import { BreadcrumbRoute } from 'src/app/core/models/models';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import { ReportLogService } from 'src/app/shared/services/report-log.service';
import { VoluntaryChangeService } from 'src/app/voluntary-change/services/voluntary-change.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from 'src/app/settings/services/settings.service';
import { RemarksService } from 'src/app/search-result/services/remarks.service';
import {
  ActionTypeText,
  LOCALSTORAGEVARS,
  OptionType,
  PAGETYPE,
  StatusType,
  STATUS_TYPE_MESSAGE
} from 'src/app/core/enums/enums';

@Component({
  selector: 'app-breadcumb',
  templateUrl: './breadcumb.component.html',
  styleUrls: ['./breadcumb.component.scss']
})
export class BreadcumbComponent implements OnInit, OnDestroy {
  @Input() breadcrumbs: BreadcrumbRoute[];
  @Input() exceptionMode: boolean;
  @Input() connectionTimeDifference: boolean;
  @Input() showExceptionSwitch: boolean;
  @Input() loadingActions: boolean;
  @Input() pnrInfo: PnrInfo;
  @Input() set actionActive(value: string) {
    this.haveExceptionMode = this.haveException(value) ? true : false;
  }

  @Output() toogleExceptionMode = new EventEmitter<boolean>();

  remarkSavedOnProccess$: Observable<IRemarkSavedOnProccess>;

  subscriptions = new Subscription();

  listStatusTypeMessage = STATUS_TYPE_MESSAGE;
  haveExceptionMode: boolean;
  actualOption: string;
  showModal: boolean;
  isNotExchangeAllowed$: Observable<boolean>;
  alternativeFlow$: Observable<boolean>;
  error: boolean;
  validForm: boolean = false;
  formCloseReason: FormGroup;
  isaFailureAgent: boolean = false;
  isExceptionSwitchDisabled: boolean = false;
  readyToRemark: boolean = false;
  acceptDisabled: boolean = false;
  remarkSaved: boolean = false;
  currentOptionType = OptionType.ClosePNR;

  constructor(
    private fb: FormBuilder,
    private vcService: VoluntaryChangeService,
    private pnrService: ItineraryService,
    private reportLog: ReportLogService,
    private settingsService: SettingsService,
    private remarksService: RemarksService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isNotExchangeAllowed$ = this.vcService.getNotExchangeAllowed();
    this.alternativeFlow$ = this.vcService.getIsNewFlow();
    this.remarkSavedOnProccess$ = this.remarksService.getRemarkSavedOnProccess();

    this.formCloseReason = this.fb.group({
      reason: ['', Validators.required],
      detail: ['']
    });

    this.callComponentSubscriptions();
  }

  callComponentSubscriptions() {
    this.subscriptions.add(
      this.remarkSavedOnProccess$.subscribe((response) => {
        this.remarkSaved = response?.closePNR;

        if (response?.closePNR) {
          this.acceptDisabled = false;
        }
      })
    );
  }

  isItinerary() {
    return this.router.url.includes(PAGETYPE.itineraryInfo);
  }

  haveException(value: string): boolean {
    this.actualOption = value;
    return value === OptionType.Cancellation || value === OptionType.VoluntaryChange;
  }

  // setReporLog
  SetReportLog(action, statusType: StatusType, error?: string) {
    switch (statusType) {
      case StatusType.FinishByUser:
        this.reportLog.FinishByUser(action, error);
        break;
      case StatusType.TimeOut:
        this.reportLog.TimeOut(action);
        break;
      case StatusType.failureUser:
        this.reportLog.failureUser(action, error);
        break;
      case StatusType.Success:
        this.reportLog.Success(action, error);
        break;
      case StatusType.successClient:
        this.reportLog.successClient(action);
        break;
    }
  }

  changeOption(event: Event) {
    const value = parseInt((event.target as HTMLSelectElement).value);
    if (value === StatusType.failureUser) {
      this.isaFailureAgent = true;
      this.formCloseReason.controls['detail'].setValidators(Validators.required);
      this.formCloseReason.controls['detail'].reset();
    } else {
      this.isaFailureAgent = false;
      this.formCloseReason.controls['detail'].clearValidators();
      this.formCloseReason.controls['detail'].reset();
    }
  }

  OpenModal() {
    this.showModal = true;
  }

  exit() {
    if (this.remarkSaved) {
      this.terminateAppSesion();
    } else {
      this.showModal = false;
    }
  }

  goToSearch(breadcrumb: any) {
    if (breadcrumb.route === OptionType.Dashboard) {
      this.SetReportLog(ActionTypeText.NA, StatusType.FinishByUser);
    }
    if (breadcrumb.route === 'itinerary') {
      this.SetReportLog(ActionTypeText.NA, StatusType.FinishByUser);
    }
  }

  FinishByUser() {
    if (this.formCloseReason.valid) {
      this.validForm = false;
      localStorage.removeItem(LOCALSTORAGEVARS.FormExchanges);

      this.SetReportLog(
        this.actualOptionMapping(),
        parseInt(this.formCloseReason.value.reason),
        this.formCloseReason.value.detail
      );

      this.readyToRemark = true;
      this.acceptDisabled = true;
    } else {
      this.validForm = true;
      this.readyToRemark = false;
    }
  }

  terminateAppSesion() {
    this.subscriptions.add(
      this.settingsService.getClientIsAirline().subscribe((isAirline) => {
        if (isAirline) {
          this.router.navigate([PAGETYPE.endProcess]);
        } else {
          this.pnrService.navigateToWithParams(PAGETYPE.dashboard);
        }
      })
    );
  }

  showAcceptFooter() {
    return;
  }

  actualOptionMapping() {
    switch (this.actualOption) {
      case OptionType.Cancellation:
        return ActionTypeText.Cancellation;
      case OptionType.ExchangeNoCost:
        return ActionTypeText.Reschedule;
      case OptionType.VoluntaryChange:
        return ActionTypeText.Change;
      case OptionType.SpecialRequest:
        return ActionTypeText.SpecialRequest;
      case OptionType.OpenTicket:
        return ActionTypeText.TicketOpening;
      case null:
        return ActionTypeText.NA;
      case undefined:
        return ActionTypeText.NA;
      case '':
        return ActionTypeText.NA;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
